import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { NavDropdown, Navbar, Nav } from "react-bootstrap";
import { USER_ROLES, decodeToken, isAdmin, isSoru } from "../helper/constants";
import "../App.css";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import logo from "../theme/assets/surucu_logo.png";
import "./NavigationBar/NavigationBar.css";

function NavigationBar() {
  const { t } = useTranslation(["navbar"]);
  const location = useLocation();
  const { isAuthenticated, logout, user } = useAuth();

  const [currentLanguage, setCurrentLanguage] = useState("Türkçe");
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage && user?.languages) {
      user.languages.forEach(
        (item) =>
          item.value === storedLanguage && setCurrentLanguage(item.label)
      );
      i18next.changeLanguage(storedLanguage);
    }
  }, [user]);

  useEffect(() => {
    const decoded = decodeToken();
    const roleId = decoded ? decoded.role : null;
    setRole(roleId);
  }, [user]);

  const onChangeLanguage = (lang) => {
    i18next.changeLanguage(lang.value);
    setCurrentLanguage(lang.label);
    localStorage.setItem("selectedLanguage", lang.value);
  };

  const isActive = (path) => location.pathname === path || (path !== "/" && location.pathname.startsWith(path));

  return (
    <div>
      {isAuthenticated && user?.course?.isPayed === true && (
        <Navbar
          expand="lg"
          className="nav-modern"
          variant="light"
        >
          <div className="container-fluid px-3 px-lg-4">
            <Navbar.Brand className="spin-animation" as={Link} to="/">
              <img
                id="icon"
                src={user?.course?.icon}
                className="d-inline-block align-top"
                alt="Logo"
                height="44"
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link
                  as={Link}
                  id="main"
                  to="/"
                  active={isActive("/") && location.pathname === "/"}
                >
                  {t("navbar:main-page")}
                </Nav.Link>
                <Nav.Link as={Link} id="examcates" to="/examcates" active={isActive("/examcates")}>
                  {t("navbar:exams")}
                </Nav.Link>
                <Nav.Link as={Link} id="books" to="/books" active={isActive("/books")}>
                  {t("navbar:books")}
                </Nav.Link>
              </Nav>

              <div className="nav-right">
                <NavDropdown
                  title={currentLanguage}
                  id="basic-nav-dropdown"
                  className="nav-lang-dropdown"
                  align="end"
                >
                  {user?.languages?.map((item) => (
                    <NavDropdown.Item
                      key={item.id}
                      id={item.id}
                      onClick={() => onChangeLanguage(item)}
                    >
                      {item.label}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

                <img src={logo} alt="Logo" className="nav-right-logo" />

                <NavDropdown
                  title={user?.firstName + " " + user?.lastName}
                  id="nav-dropdown"
                  className="nav-user-dropdown"
                  align="end"
                >
                  {(isAdmin(role) || isSoru(role) || role === USER_ROLES.COURSEADMIN) && (
                    <>
                      <NavDropdown.Item key="users" as={Link} id="users" to="/users">
                        Yönetici Paneli
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                    </>
                  )}
                  <NavDropdown.Item
                    key="logout"
                    onClick={logout}
                    id="logout"
                    className="logout-item"
                    style={{ color: "#dc2626" }}
                  >
                    Çıkış Yap
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </Navbar.Collapse>
          </div>
        </Navbar>
      )}
    </div>
  );
}

export default NavigationBar;
